module.exports = __webpack_public_path__ + "img/icon_parkingCoupon.92cee0bc.png";